import {inject, Pipe, PipeTransform} from "@angular/core";
import {DatePipe} from "@angular/common";

@Pipe({
	name: "durationLabel",
})
export class DurationLabelPipe implements PipeTransform {
	readonly #datePipe = inject(DatePipe);

	transform(value: Date | string | number, hideSeconds?: boolean): string | null {
		if (!value) {
			return this.#datePipe.transform(0, "mm:ss");
		}

		let timestamp: number;
		if (typeof value === "number") {
			timestamp = value;
		} else {
			const date = new Date(value);
			timestamp = date.getTime();
		}

		if (timestamp >= 3600_000) {
			return this.#datePipe.transform(value, hideSeconds ? "HH:mm" : "HH:mm:ss", "UTC");
		} else {
			return this.#datePipe.transform(value, hideSeconds ? "mm" : "mm:ss", "UTC");
		}
	}
}
